/**
 * imageSeo.js — kontekstowe opisy zdjęć (alt) pod SEO i wyszukiwarki AI.
 *
 * Buduje sensowny, PRAWDZIWY opis zdjęcia z danych encji (rasa + nazwa + miasto),
 * bez zmyślania. Używane na stronach publicznych (hodowla/reproduktor/miot/firma),
 * gdzie wcześniej wiele zdjęć miało pusty lub generyczny `alt`.
 *
 * Przykłady:
 *   buildImageAlt({ kind:'kennel', name:'APIS-HOF', breed:'Owczarek niemiecki', city:'Warszawa' })
 *     → "Owczarek niemiecki – Hodowla APIS-HOF, Warszawa"
 *   buildImageAlt({ kind:'stud', name:'KING', breed:'Owczarek niemiecki', city:'Warszawa', index:2 })
 *     → "Owczarek niemiecki – Reproduktor KING, Warszawa (zdjęcie 3)"
 */

const KIND_LABELS = { kennel: 'Hodowla', stud: 'Reproduktor', litter: 'Miot' };

const titleCase = (s) => (s || '').trim().replace(/(^|\s|-)([a-ząćęłńóśźż])/g, (m, sep, ch) => sep + ch.toUpperCase());

export function buildImageAlt({ kind, name, breed, city, index, suffix } = {}) {
  const label = KIND_LABELS[kind];
  let who = (name || '').trim();
  if (label && who && !who.toLowerCase().includes(label.toLowerCase())) who = `${label} ${who}`;
  if (!who) who = label || '';

  let base = breed && who ? `${breed} – ${who}` : (who || breed || 'Zdjęcie');
  if (city) base += `, ${titleCase(city)}`;
  if (Number.isInteger(index)) base += ` (zdjęcie ${index + 1})`;
  else if (suffix) base += ` – ${suffix}`;

  return base.slice(0, 125);
}

export default buildImageAlt;
